import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import useDialog from "../../hooks/useDialog";
import { OfferPreviewDialog } from "./OfferPreviewDialog";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";

export const OfferPreviewButton = (props) => {
    const { t } = useTranslation();

    const [openOfferPreviewDialog, onOpenOfferopenOfferPreviewDialog, onCloseOfferPreviewDialog] =
        useDialog();

    return (
        <>
            <Button
                variant="contained"
                color="primary"
                fullWidth
                size="small"
                onClick={onOpenOfferopenOfferPreviewDialog}
                startIcon={<RemoveRedEyeOutlinedIcon fontSize="medium" sx={{margin: "3px"}}/>}
                >
                {t("offers.offerGenerator")}
                
            </Button>
            {openOfferPreviewDialog && (
                <OfferPreviewDialog
                    open={openOfferPreviewDialog}
                    onClose={onCloseOfferPreviewDialog}
                />
            )}
        </>
    )
};
